export const sortingData = (data, shortingOrder, key) => {
  const sortingMap = {};
  shortingOrder.forEach((orderKey, index) => {
    sortingMap[orderKey] = index;
  });

  // Sorting the data array according to the predefined sorting order
  data.sort((a, b) => {
    const indexA = sortingMap[a[key]] || Infinity;
    const indexB = sortingMap[b[key]] || Infinity;

    return indexA - indexB;
  });
  return data;
};
